import Button from "../../../components/Button";
import phone from "../../../assets/phone.svg";
import chat from "../../../assets/chat.svg";

export default function Video({ onClose }: { onClose: () => void }) {
  return (
    <div
      style={{
        zIndex: 99999,
        position: "fixed",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        display: "flex",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        style={{
          padding: "20px 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "between",
          justifyContent: "space-between",
          backgroundColor: "white",
          height: "90%",
          width: "95%",
          maxWidth: "600px",
          margin: "auto",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <span
          onClick={onClose}
          className="px-3"
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            marginLeft: "auto",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          Chiudi
        </span>
        <h5 className="px-3 mt-4">
          Nuccio Parisi, amministratore e socio delle onoranze funebri Parisi
          Mario.
        </h5>
        <div
          style={{
            width: "100%",
            maxWidth: "800px",
            margin: "0 auto",
            marginTop: "10px",
            height: "40vh",
          }}
        >
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/GWBrx0KGHPk?si=FPajBvyUjjhZ8PkG"
            title="YouTube video player"
            // frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            // referrerpolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
        <div
          className="d-flex flex-column gap-2 w100 px-3 mb-auto"
          style={{ maxWidth: "400px", margin: "0 auto" }}
        >
          <Button
            id="cta-cremation-2"
            onClickLink={`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_PHONE_NUMBER}&text=Salve, vorrei sapere di più sui vostri servizi.`}
            secondary
            icon={chat}
            text="Preventivo su WhatsApp"
            className="tag-manager-call w100 mt-1 h"
          />
          <Button
            id="cta-cremation-1"
            onClickLink={`tel:${process.env.REACT_APP_PHONE_NUMBER}`}
            text="Chiama Subito (24h)"
            icon={phone}
            className="tag-manager-call w100 h"
          />
        </div>
      </div>
    </div>
  );
}
